import React from "react";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import styled from "styled-components";
import { FaFileExcel } from "react-icons/fa";

const FileStatusesExcelDownload = ({ data }) => {
    if (!data) {
        return null;
    }
    const formatData = () => {
        const formattedData = data.map(({ fileName, productName, fileUploadDate, fileUploadBy, fileStatusDescr, totalRecords, processedRecords, pendingRecords, errorRecords, disbursedAmount, balanceBefore, balanceAfter, transSuccessRecords, fileStatusCode }) => {
            return {
                "File Name": fileName,
                "Product Name": productName,
                "File Upload Date": fileUploadDate,
                "File Upload By": fileUploadBy,
                "File Status Description": fileStatusDescr,
                Status: fileStatusCode === "P" ? "Pending" : fileStatusCode === "S" ? "Success" : fileStatusCode === "A" ? "MC Approved" : fileStatusCode === "D" ? "Done" : null,
                "Total Records": totalRecords,
                "Processed Records": processedRecords,
                "Pending Records": pendingRecords,
                "Error Records": errorRecords,
                "Disbursed Amount": disbursedAmount,
                "Balance Before": balanceBefore,
                "Balance After": balanceAfter,
                "Success Records": transSuccessRecords,
            };
        });
        return formattedData;
    };

    const downloadExcel = () => {
        const formattedData = formatData();
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Zbiz File Statuses");
        const fileBuffer = XLSX.write(workbook, {
            type: "buffer",
            bookType: "xlsx",
        });
        saveAs(new Blob([fileBuffer], { type: "application/octet-stream" }), "Zbiz File Statuses.xlsx");
    };

    return (
        <div>
            <Button onClick={downloadExcel}>
                <FaFileExcel /> Download Excel
            </Button>
        </div>
    );
};

const Button = styled.button`
    background-color: #3ca2bb;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    cursor: pointer;
    display: flex;
    align-items: center;

    svg {
        margin-right: 0.5rem;
        transition: transform 0.3s ease-in-out;
    }

    &:hover {
        svg {
            transform: rotate3d(1, 1, 1, 45deg);
        }
    }
`;

export default FileStatusesExcelDownload;
